/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Box, Typography, Grid, TextField, MenuItem } from '@mui/material';
import { useSnackbar } from 'notistack';
import * as eqpMonitorApi from '../../lib/api/eqpMonitor';
import EqpDayDataView from '../../components/eqpmng/EqpDayDataView';
import BreadcrumbsContainer from '../common/breadcurmbs/BreadcrumbsContainer';

// (2026-10-19) 하루치 데이터(타임라인·차트·이벤트)는 EqpDayDataView 로 빼서 장비 상세창의
// "수집 데이터" 탭과 같이 쓴다. 이 화면은 장비 선택기만 자체로 들고, 나머지는 그 컴포넌트에 맡긴다.
const EqpDataMngContainer = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { enqueueSnackbar } = useSnackbar();

  const [machines, setMachines] = useState([]);
  const [eqpUuid, setEqpUuid]   = useState(() => new URLSearchParams(location.search).get('eqpUuid') || '');

  // 장비 선택 목록은 모니터링 보드에서 가져온다(모니터링이 켜진 장비만 대상이 된다)
  useEffect(() => {
    eqpMonitorApi.getMonitorBoard()
      .then((res) => {
        const list = eqpMonitorApi.extractList(res);
        setMachines(list);
        setEqpUuid((prev) => prev || (list[0]?.eqpUuid ?? ''));
      })
      .catch(() => enqueueSnackbar('장비 목록 조회 실패', { variant: 'error' }));
  }, []);

  const handleMachineChange = (val) => {
    setEqpUuid(val);
    navigate(`${location.pathname}?eqpUuid=${val}`, { replace: true });
  };

  const machineLabel = machines.find((m) => m.eqpUuid === eqpUuid)?.eqpNm;

  return (
    <Box sx={{ p: 3 }}>
      <BreadcrumbsContainer title="기준정보/수집 데이터" />
      <Typography variant="h5" fontWeight={700} mb={2}>수집 데이터</Typography>

      <EqpDayDataView
        eqpUuid={eqpUuid}
        machineLabel={machineLabel}
        filterPrefix={(
          <Grid item xs={12} sm={5} md={4}>
            <TextField
              select fullWidth size="small" label="장비"
              value={eqpUuid}
              onChange={(e) => handleMachineChange(e.target.value)}
            >
              {machines.length === 0 && <MenuItem value="">모니터링 중인 장비 없음</MenuItem>}
              {machines.map((m) => (
                <MenuItem key={m.eqpUuid} value={m.eqpUuid}>{m.eqpNm} ({m.eqpCd})</MenuItem>
              ))}
            </TextField>
          </Grid>
        )}
      />
    </Box>
  );
};

export default EqpDataMngContainer;
